import { environment } from './environment.staging';

const URL_BASE_LOCAL = environment.baseUrlLocal;
const URL_BASE_VERSION_LOCAL = environment.baseUrlVersion;

export const BASE_HREF = environment.baseHref;
export const BASE_API = `${URL_BASE_LOCAL}${URL_BASE_VERSION_LOCAL}`;

const API_BASE_CONFIG = `${BASE_API}${environment.apiEntityConfig}`;
const API_BASE_STOCK = `${BASE_API}${environment.apiStock}`;

const URL_ENTITY = environment.apiEntity;

export const API_BASE_AUTH = `${URL_BASE_LOCAL}${environment.apiBaseUser}`;
export const API_BASE_USER = `${URL_BASE_LOCAL}${environment.apiEntityUser}`;
export const API_BASE_ROLE = `${URL_BASE_LOCAL}${environment.apiEntityUserRole}`;

export const URL_AUTH_SIGNIN = `${API_BASE_AUTH}${environment.apiEntityLogin}`;
export const URL_AUTH_REGISTER = `${API_BASE_AUTH}${environment.apiEntityRegister}`;
export const URL_AUTH_PASSWORD_RESET = `${API_BASE_AUTH}${environment.apiEntityResetPassword}`;
export const URL_AUTH_PASSWORD_FORGOT = `${API_BASE_AUTH}${environment.apiEntityForgotPassword}`;
export const URL_AUTH_TOKEN_REFRESH = `${API_BASE_AUTH}${environment.apiEntityRefreshToken}`;

export const API_BASE_ENTITY = `${BASE_API}${URL_ENTITY}`;
export const API_BASE_TAG = `${BASE_API}${environment.apiTag}`;
export const API_BASE_ON_SITE_COLLECTION = `${BASE_API}/on-site-collection`;
export const API_BASE_TASK = `${API_BASE_ON_SITE_COLLECTION}/tasks`;
export const API_BASE_EXECUTIVES = `${API_BASE_ON_SITE_COLLECTION}/cash-collection-officers`;
export const API_BASE_LOCATION = `${BASE_API}${environment.apiLocation}`;
export const API_BASE_CURRENCY = `${BASE_API}${environment.apiCurrency}`;

export const URL_BASE_AGENT = `${API_BASE_CONFIG}${environment.apiEntityAgent}`;
export const URL_BASE_BROKER = `${API_BASE_CONFIG}${environment.apiEntityBroker}`;
export const URL_BROKER_PROVIDER_RELATION = `${BASE_API}${environment.apiRelationBroker}`;
export const URL_BASE_CLIENT = `${API_BASE_CONFIG}${environment.apiEntityCustomer}`;
export const URL_BASE_CLIENT_ACTIVE = `${API_BASE_ENTITY}${environment.apiEntityCustomer}`;
export const URL_BASE_PROVIDER = `${API_BASE_CONFIG}${environment.apiEntityProvider}`;

export const API_BASE_OPERATION = `${BASE_API}${environment.apiOperation}`;
export const URL_COMMISSION_CONFIG = `${API_BASE_OPERATION}${environment.apiCommissionConfig}`;
export const API_BASE_BENEFIT = `${API_BASE_OPERATION}${environment.apiOperationBenefit}`;

export const API_BASE_BANK = `${BASE_API}${environment.apiOperationBank}`;
export const URL_BENEFIT_REASON = `${API_BASE_BENEFIT}${environment.apiOperationReason}`;
export const URL_BENEFIT_TYPE = `${API_BASE_OPERATION}${environment.apiOperationType}`;

export const BASE_SINGLE_TRANSACTION = environment.apiTransaction;
export const API_BASE_OPERATION_TRANSACTION = `${API_BASE_OPERATION}${BASE_SINGLE_TRANSACTION}`;

export const API_BASE_CHECKING_ACCOUNT = `${BASE_API}${environment.apiOperationCheckingAccount}`;
export const API_ENTITY_TRANSFER = environment.apiEntityTransfer;

export const BASE_SINGLE_CHECK = environment.apiOperationCheck;
export const API_BASE_OPERATION_CHECK = `${API_BASE_OPERATION}${BASE_SINGLE_CHECK}`;

export const BASE_SINGLE_ECHEQ = environment.apiOperationEcheq;
export const API_BASE_OPERATION_ECHEQ = `${API_BASE_OPERATION}${BASE_SINGLE_ECHEQ}`;

export const API_BASE_CABLE = `${BASE_API}${environment.apiOperationCable}`;
export const URL_CABLE_REQUESTS = `${API_BASE_CABLE}${environment.apiCableRequests}`;
export const URL_CABLE_REQUESTS_BY_TYPE = `${URL_CABLE_REQUESTS}${environment.apiCableRequestsByType}`;
export const URL_CABLE_REQUESTS_BY_PROVIDER = `${URL_CABLE_REQUESTS}${environment.apiCableProviderRequests}`;

export const API_BASE_CRYPTO = `${BASE_API}${environment.apiOperationCrypto}`;
export const URL_CRYPTO_REQUESTS = `${API_BASE_CRYPTO}${environment.apiCryptoRequests}`;
export const URL_CRYPTO_REQUESTS_BY_TYPE = `${URL_CRYPTO_REQUESTS}${environment.apiCryptoRequestsByType}`;
export const URL_CRYPTO_REQUESTS_BY_PROVIDER = `${URL_CRYPTO_REQUESTS}${environment.apiCryptoProviderRequests}`;

export const BASE_SINGLE_COLLECTOR = environment.apiOperationCollectorAccount;
export const API_BASE_OPERATION_COLLECTOR = `${API_BASE_OPERATION}${BASE_SINGLE_COLLECTOR}`;
export const API_BASE_AUTOMATIC_DEBIT = `${API_BASE_OPERATION}/automatic-debit`;
export const API_BASE_APPROVALS = `${BASE_API}/approvals`;

export const API_BASE_OPERATION_HISTORY = `${API_BASE_OPERATION}${environment.apiOperationHistoryService}`;
export const API_BASE_OPERATION_CASH_FLOW = `${API_BASE_OPERATION}${environment.apiOperationCashFlow}`;
export const API_BASE_PENDING_BALANCES = `${API_BASE_OPERATION}/entities/operation-balances`;

export const API_BASE_DASHBOARD = `${BASE_API}${environment.apiDashboard}`;
export const URL_DASHBOARD_BALANCE_POSITION = `${API_BASE_DASHBOARD}${environment.apiDashboardBalancePosition}`;
export const URL_DASHBOARD_DAILY_POSITION = `${API_BASE_DASHBOARD}${environment.apiDashboardDailyPosition}`;
export const URL_DASHBOARD_LATEST_AUDITED_BALANCES = `${API_BASE_DASHBOARD}${environment.apiDashboardLatestAuditedBalances}`;
export const URL_DASHBOARD_UNASSIGNED_OPERATIONS = `${API_BASE_DASHBOARD}${environment.apiDashboardUnassignedOperations}`;
export const URL_DASHBOARD_REAL_BALANCES = `${API_BASE_DASHBOARD}${environment.apiDashboardRealBalances}`;
export const URL_DASHBOARD_REAL_BALANCES_BY_CURRENCY = `${API_BASE_DASHBOARD}${environment.apiDashboardRealBalancesByCurrency}`;
export const URL_DASHBOARD_REAL_BALANCES_BY_CURRENCY_LOCATION = `${API_BASE_DASHBOARD}${environment.apiDashboardRealBalancesByCurrencyLocation}`;
export const URL_DASHBOARD_REAL_BALANCES_BY_TAG = `${API_BASE_DASHBOARD}${environment.apiDashboardRealBalancesByTag}`;
export const URL_DASHBOARD_BALANCES_RECEIVABLE_PAYABLE = `${API_BASE_DASHBOARD}${environment.apiDashboardBalancesReceivablePayable}`;
export const URL_DASHBOARD_PROFITABILITY = `${API_BASE_DASHBOARD}${environment.apiDashboardProfitability}`;
export const URL_DASHBOARD_SERVICE_PPP = `${API_BASE_DASHBOARD}${environment.apiDashboardServicePpp}`;

export const BASE_SINGLE_RECEIPT = environment.apiInvoice;
export const API_BASE_OPERATION_RECEIPT = `${API_BASE_OPERATION}${BASE_SINGLE_RECEIPT}`;

export const URL_BASE_CURRENCY_AUDIT = `${API_BASE_STOCK}${environment.apiCurrencyAudit}`;
export const URL_BASE_PROVIDER_AUDIT_CONFIRM = `${API_BASE_STOCK}${environment.apiCurrencyAuditConfirmation}`;

export const BASE_SINGLE_INTERNAL = environment.apiInternal;
export const API_BASE_INTERNAL = `${API_BASE_OPERATION}${BASE_SINGLE_INTERNAL}`;
export const URL_INTERNAL_REASON = `${API_BASE_INTERNAL}${environment.apiOperationReason}`;
export const URL_ACCOUNT_BALANCE_LAST = `${API_BASE_CHECKING_ACCOUNT}${environment.apiOperationCheckingAccountLast}`;

export const URL_INTERNAL_INCOME_EXPENSES = `${API_BASE_OPERATION}${environment.apiInternalIncomeExpenses}`;

export const URL_CURRENT_ACCOUNT_BALANCES = `${API_BASE_OPERATION}${URL_ENTITY}`;
